export class Pills {
  Pills: Pill[] = [];
}

export class Pill {
  Name: string = '';
  Content: string = '';
  CssClass: string = '';
}
